import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import axios from 'axios';
import useJwt from '@/auth/jwt/useJwt';
import { isTokenExpired } from '@/auth/utils';
import { userService } from '@/_helpers/user';

// Synfusion license
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('ORg4AjUWIQA/Gnt2VVhjQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxhUH5fdXVWQGJbUUY=');

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// Element UI
import ElementUI from 'element-ui';
import './assets/scss/element-ui/index.css';
Vue.use(ElementUI);

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

axios.get(`/config/application.json?v=${Date.now()}`).then(r => {
  console.log('main', r)
  Vue.prototype.$apiUrl = r.data.apiUrl;

  const hostName = window.location.hostname;
  Vue.prototype.$ccgeoVersion = false;
  if (hostName.includes("sitonline")) {
    Vue.prototype.$ccgeoVersion = true;
  }

  const userToken = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
  if (userToken && !isTokenExpired()) {
    userService
      .getCurrentUser()
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          store.commit('userData/setUserData', response.data);
        }

        new Vue({
          router,
          store,
          render: h => h(App),
        }).$mount('#app');
      })
      .catch((error) => console.log(error))
  } else {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});

